import {AbstractControl} from '@angular/forms';

export const emailRegex = /^[0-9a-zA-Z_\.\-\+]+@[0-9a-zA-Z_.-]+?\.[0-9a-zA-Z]{2,3}$/;

export class LocalValidators {
    static email(control: AbstractControl) {
        if (control.value && !emailRegex.test(control.value)) {
            return {
                invalid_email: 'Provided email is invalid'
            };
        }
        return null;
    }
}



// WEBPACK FOOTER //
// /app/src/app/modules/utils/validators/LocalValidators.ts